import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import {
  createTemplateNotification,
  deleteTemplateNotification,
  updateTemplateNotification,
} from 'apps/templates/actions/templatesActions'
import { templateAdapter } from 'apps/templates/models/Template/adapter'
import type { AdaptedTemplate, Template } from 'shared/api/common/schemas/templates/template'
import { templateApi } from 'shared/api/requests/template'
import { createAsyncAction } from 'shared/lib/redux'

import { initialState } from './types'

export const fetchTemplatesList = createAsyncAction(
  'templatesList/fetchTemplatesList',
  async () => {
    const response = await templateApi.fetch({})
    const templates: Template[] = response.data.templates
    return templates.map(templateAdapter)
  },
)

export const templatesListSlice = createSlice({
  name: 'templatesList',
  initialState,
  reducers: {
    resetTemplatesList: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTemplatesList.pending.type, (state) => {
      state.fetchStatus = 'loading'
    })

    builder
      .addCase(
        fetchTemplatesList.fulfilled.type,
        (state, action: PayloadAction<AdaptedTemplate[]>) => {
          state.items = action.payload
          state.fetchStatus = 'succeeded'
        },
      )

      .addCase(fetchTemplatesList.rejected.type, (state) => {
        state.fetchStatus = 'failed'
      })
      .addCase(createTemplateNotification, (state, action) => {
        state.items.push(action.payload.item)
      })
      .addCase(updateTemplateNotification, (state, action) => {
        const adaptedTemplate = action.payload.item
        const index = state.items.findIndex((template) => template.id === adaptedTemplate.id)
        if (index !== -1) {
          state.items[index] = adaptedTemplate
        }
      })
      .addCase(deleteTemplateNotification, (state, action) => {
        state.items = state.items.filter((template) => template.id !== action.payload.id)
      })
  },
})

export const { resetTemplatesList } = templatesListSlice.actions
export const templatesListReducer = templatesListSlice.reducer
